export const RECEIPT_SUCCESS_TITLE = 'Готово!';

export const RECEIPT_SUCCESS_DESCRIPTION = 'Мы пришлем уведомление, когда чек будет сформирован';
